function importAll (r) {
    r.keys().forEach(r);
  }
  
  window.$ = $
  window.jQuery = $
  import 'jquery.scrollto'
  import Rails from "@rails/ujs"
  Rails.start()
  
  import 'slick-carousel'
  import 'slick-carousel/slick/slick.css'
  import 'jquery-colorbox'
  
  importAll(require.context('advent/images', true))
  import 'normalize.css'
  import 'advent/styles/advent.sass'
  import 'scrolldepth/jquery.scrolldepth.min.js'
